// extracted by mini-css-extract-plugin
export default {"beer_info":"styles_beer_info__RrX3k","go_back_button":"styles_go_back_button__54Mmw","beer_card":"styles_beer_card__iyoLS","favorite_star":"styles_favorite_star__eozMC"};